import { PunctualityFilterMeta } from '@src/main/modules/reports/ui/mapPunctualityFiltersToCriteria';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { useMemo } from 'react';

export const usePunctualityFilters = (startDate: Date | null, endDate: Date | null) =>
  useMemo<PunctualityFilterMeta>(
    () => ({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },

      carrierCode: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      flightNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      departureAirport: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      arrivalAirport: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      aircraftRegistration: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      employeeId: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },

      flightDate: {
        operator: FilterOperator.AND,
        constraints: [
          {
            value: [startDate ? new Date(startDate) : null, endDate ? new Date(endDate) : null],
            matchMode: FilterMatchMode.BETWEEN,
          },
        ],
      },
      updatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.BETWEEN }],
      },
    }),
    [startDate, endDate],
  );
